import { render, staticRenderFns } from "./UpDownCustomerNetWork2.vue?vue&type=template&id=995a8e30&scoped=true"
import script from "./UpDownCustomerNetWork2.vue?vue&type=script&lang=js"
export * from "./UpDownCustomerNetWork2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995a8e30",
  null
  
)

export default component.exports